<script setup lang="ts">
import LogoSvg from "@/assets/logo.svg";
</script>

<template>
  <LogoSvg
    class="logo"
    aria-label="Kiezkompass Logo bestehend aus einem halbierten Karten Marker und dem Schriftzug Kiezkompass"
  />
</template>

<style scoped>
.logo {
  color: var(--color-primary);
}
</style>
